export const isEmptyValue = (value: unknown): boolean =>
  value === undefined ||
  value === null ||
  Number.isNaN(value) ||
  value === "null" ||
  (typeof value === "object" && Object.keys(value).length === 0) ||
  (typeof value === "string" && value.trim().length === 0);
